import { axiosInstanceWebsite } from "../instance";

export interface ConfioConnectionTokenResponse {
  token: string;
  expires_at: string;
}

export interface ConfioIntegrationResponse {
  connected: boolean;
  active: boolean;
  organization: string | null;
  store: string | null;
  connected_at: string | null;
}

export const generateConfioConnectionToken = async (): Promise<ConfioConnectionTokenResponse> => {
  const response = await axiosInstanceWebsite.post(`/confio/connect-token`);
  return response.data;
};

export const getConfioIntegration = async (): Promise<ConfioIntegrationResponse> => {
  const response = await axiosInstanceWebsite.get(`/confio/integration`);
  return response.data;
};

export const disconnectConfioIntegration = async (): Promise<ConfioIntegrationResponse> => {
  const response = await axiosInstanceWebsite.post(`/confio/integration/disconnect`);
  return response.data;
};
